<template>
  <v-container class="fluid-max-width pa-0">
    <v-breadcrumbs :items="breadcrumbItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-stepper v-model="stepper" vertical class="shaft-stepper">
      <v-stepper-step
        :complete="stepper > 1"
        :editable="stepper > 1"
        edit-icon="mdi-check"
        step="1"
      >
        <h5 class="text-uppercase">Schachtaufbau Basisinformationen</h5>
      </v-stepper-step>

      <v-stepper-content step="1">
        <FormEditBuildup1
          :shaft="currentShaft"
          :coverChoices="coverChoices"
          :clampChoices="clampChoices"
          :coneChoices="coneChoices"
          :sealingChoices="sealingChoices"
          @submit="
            () => {
              stepper = 2;
              componentKey++; // force shaft image to re-render
            }
          "
        />
      </v-stepper-content>

      <v-stepper-step
        :complete="stepper > 2"
        :editable="stepper > 2"
        edit-icon="mdi-check"
        step="2"
      >
        <h5 class="text-uppercase">Schachtaufbau</h5>
      </v-stepper-step>

      <v-stepper-content step="2">
        <FormEditBuildup2
          :shaft="currentShaft"
          :buildupChoices="buildupChoices"
          :coneChoices="coneChoices"
          @submit="$router.back()"
          :key="componentKey"
        />
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FormEditBuildup1 from '@/components/FormEditBuildup1.vue';
import FormEditBuildup2 from '@/components/FormEditBuildup2.vue';

export default {
  name: 'EditBuildup',
  components: {
    FormEditBuildup1,
    FormEditBuildup2,
  },
  data: () => ({
    tab: undefined,
    draw: undefined,
    stepper: 1,
    componentKey: 0,
    breadcrumbItems: [
      {
        text: 'Home',
        disabled: false,
        to: '/',
      },
      {
        text: 'Baustellen',
        disabled: false,
        to: '/baustellen',
      },
      {
        text: 'Baustelle',
        disabled: false,
        to: '/baustellen/',
      },
      {
        text: 'Schacht',
        disabled: false,
        to: '/schacht/',
        exact: true,
      },
      {
        text: 'Schachtaufbau',
        disabled: true,
      },
    ],
  }),
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'user',
      'sites',
      'currentShaft',
      'selectChoices',
    ]),
    step() {
      return this.$route.params.step;
    },
    clampChoices() {
      if (this.selectChoices) {
        var item = this.selectChoices.find(item => item.field === 'clamp');
        if (item) return item.options.choices;
      }
      return [];
    },
    coverChoices() {
      if (this.selectChoices) {
        var item = this.selectChoices.find(item => item.field === 'cover');
        if (item) return item.options.choices;
      }
      return [];
    },
    buildupChoices() {
      if (this.selectChoices) {
        var item = this.selectChoices.find(
          item =>
            item.field === 'buildup' &&
            item.collection === 'shaft_options_buildup',
        );

        if (item) {
          return item.options.choices.filter(
            choice => choice.type === 'Schachtringe',
          );
        }
      }
      return [];
    },
    coneChoices() {
      if (this.selectChoices) {
        var item = this.selectChoices.find(
          item =>
            item.field === 'buildup' &&
            item.collection === 'shaft_options_buildup',
        );
        if (item) {
          return item.options.choices.filter(
            choice =>
              choice.type === 'Konus' || choice.type === 'Flachabdeckung',
          );
        }
      }
      return [];
    },
    sealingChoices() {
      if (this.selectChoices) {
        var item = this.selectChoices.find(item => item.field === 'sealing');
        if (item) return item.options.choices;
      }
      return [];
    },
  },
  async created() {
    this.init();
    await this.autoLogin();
    await this.getSelectChoices();
    if (!this.currentShaft) {
      await this.getCurrentShaft(this.$route.params.id);
    }
    this.init();
  },
  methods: {
    ...mapActions([
      'setLoading',
      'autoLogin',
      'getCurrentShaft',
      'getSelectChoices',
    ]),
    init() {
      if (this.currentShaft) {
        this.breadcrumbItems[2].text = this.currentShaft.site_id.name;
        this.breadcrumbItems[2].to =
          '/baustellen/' + this.currentShaft.site_id.id;
        this.breadcrumbItems[3].text = this.currentShaft.title;
        this.breadcrumbItems[3].to = '/schacht/' + this.currentShaft.id;
        this.setLoading(false);
      }
    },
  },
};
</script>

<style scoped>
.shaft-stepper {
  box-shadow: none;
}
</style>
